var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'route_performance.title' | translate}}</b>\n<hr class=\"margin-bottom-10\">\n</div>\n<div class=\"remove-pad col-sm-12\">\n<hr class=\"cash-variances-line-section\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"text-center alert alert-danger margin-top-05\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</form>";
var id1="route_performance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/reporting/components/route_performance/route_performance.html
// module id = 2761
// module chunks = 1